import * as moment from 'moment';
const DT_TEMPLATE = /(\d{4}-\d{2}-\d{2})[ T](\d{2}:\d{2}:\d{2})\s*(.*)/;
const ISO_8601 = moment.ISO_8601;
const ISO_FMT = 'YYYY-MM-DDTHH:mm:ssZ';
function _normalized(str, tmplt = DT_TEMPLATE) {
    const parts = str.match(tmplt);
    if (parts == null) {
        return '';
    }
    let tz = parts[3];
    if (tz !== '') {
        const tzsign = tz[0];
        tz = tz.slice(1);
        if (tz.length === 2) {
            tz = tzsign + tz + ':00';
        }
        else if (tz.length === 4) {
            tz = tzsign + tz.slice(0, 2) + ':' + tz.slice(2);
        }
        else {
            tz = tzsign + tz;
        }
    }
    else {
        tz = 'Z';
    }
    return parts.slice(1, 3).join('T') + tz;
}
export const fromString = (str, tmplt = DT_TEMPLATE) => {
    return moment(_normalized(str, tmplt), ISO_8601).toDate();
};
export const dateToJSON = (dt) => {
    return moment(dt)
        .utc()
        .format(ISO_FMT);
};
export const formattedFromString = (str, format = 'lll', tmplt = DT_TEMPLATE) => {
    return moment(_normalized(str, tmplt), ISO_8601).format(format);
};
export const asMoment = (str, tmplt = DT_TEMPLATE) => {
    return moment(_normalized(str, tmplt), ISO_8601);
};
